import type { SVGProps } from "react";
import * as React from "react";
const SvgChatBubbleBottomCenterPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 3h-4a8 8 0 0 0-8 8c0 6.5 7 9.5 12 11.5V19a8 8 0 1 0 0-16Zm-6 7h3V7h2v3h3v2h-3v3h-2v-3H8v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChatBubbleBottomCenterPlus;
